const laptopBasicSupportService = {
  title: "Laptop Basic Support",
  icon: "💻",
  rateCardKey: "laptop",
  shortDescription:
    "Basic laptop diagnosis, startup issue checks, software-side support, and setup assistance.",
  longDescription:
    "Book basic laptop support for startup issues, simple software-side help, format / setup support, and general device diagnosis.",
  consultationNote:
    "Board-level repair, screen replacement, and chip-level issues should be separately scoped after diagnosis.",
  responsePromise:
    "Assignment depends on issue type and technician capability.",
  warrantyPolicy:
    "Support depends on device health, software condition, and actual intervention performed.",
  subServices: [
    {
      id: "laptop-diagnosis",
      title: "Laptop Diagnosis",
      icon: "🔍",
      group: "Inspection",
      description:
        "Basic diagnosis for not starting, hanging, overheating, or abnormal behavior.",
      basePrice: 299,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "laptop-software-support",
      title: "Basic Software Support",
      icon: "🧩",
      group: "Software",
      description:
        "Basic support for setup, basic configuration, or simple software-side issue review.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "laptop-os-install",
      title: "OS Installation / Reset Support",
      icon: "💾",
      group: "Software",
      description:
        "Basic operating system installation or reset support where feasible.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "60-120 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "laptop-cleaning-basic",
      title: "Basic Laptop Cleaning / Check",
      icon: "🧼",
      group: "Maintenance",
      description:
        "Basic cleaning and performance-side check support, excluding deep board repair.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "Service completion only",
      unit: "job",
    },
  ],
};

export default laptopBasicSupportService;